<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="!!backButtonRoute"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedTabIndex"
    ref="gc-base-layout"
    class="bill-of-materials"
    :routeChangeCallBack="onRouteChangeCallBack"
  >
    <slot></slot>

    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Bill of Materials'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Bill of Materials # ' + formModel.BillNo"
        :secondaryLabel="undefined"
        v-if="loaded"
      />
    </template>

    <div class="split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <dx-data-grid
              :height="getGridHeight"
              :columns="getGridColumns"
              :data-source="getDataSource"
              @toolbar-preparing="onToolbarPreparing($event)"
              @content-ready="onContentReady"
              ref="data-grid"
              @row-click="onRowClick"
              :columnChooser="{
                enabled: false,
              }"
            >
              <DxPaging :page-size="200" :enabled="false" />

              <DxPager :visible="false" />

              <template #RecordTemplate="{ data }">
                <GcRecordCell
                  :data="data"
                  :primary="[
                    {
                      dataField: 'ProcessDescription',
                    },
                  ]"
                  :secondary="[
                    {
                      dataField: 'ProcessCode',
                    },
                  ]"
                />
              </template>
              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preload-enabled="true"
              />
            </dx-data-grid>
          </div>
        </template>

        <template #rightContent>
          <gc-form-header-toolbar
            :toolbar-options="getHeaderToolbar"
            :data-model="formModel"
            :backRoute="getFormBackURL"
            :formLocation="'Left'"
            v-if="loaded"
            :baseView="baseView"
            :customButtons="getHeaderToolbar.customButtons"
          ></gc-form-header-toolbar>

          <div class="view-card responsive-paddings split-view-form">
            <GcForm
              :formOptions="formOptions"
              :formItems="getFormItems"
              :isNormal="true"
              :data-model="formModel"
              v-if="loaded"
              :formMode="baseView.mode"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'split-view-form'"
              :formLocation="'normal'"
              :formContentReady="formContentReady"
              :formHeight="getFormHeight"
              ref="split-view-form"
            />
          </div>
        </template>
      </gc-split-view>
    </div>
  </GcBaseLayout>
</template>

<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import FormMixin from "@/_mixins/form.mixin";
import RouteMixin from "@/_mixins/route.mixin";

import {
  BillOfMaterialsTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/production/bill-of-materials-tabs";
import { mapGetters } from "vuex";
import { FeatureStorage } from "../../../_services/storage";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { BillOfMaterialsService } from "../../../_services/api/production/bill-of-materials.service";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";
import { custom } from "devextreme/ui/dialog";
export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      formModel: {
        ProcessCode: "",
        ProcessDescription: "",
        RatePerHour: null,
        SetupMinutes: 0,
        SetupHours: 0,

        TimeMinutes: 0,
        TimeHours: 0,

        ProcessOffsetMinutes: 0,
        ProcessOffsetHours: 0,
        Comment: "",
        ProcessOffsetAnchor: "EndOfProcess",
        Sequence: null,

        BillNo: undefined,
        DateChanged: null,
        DateCreated: null,
        CreatedBy: null,
        ChangedBy: null,
      },
      isValid: false,
      formOptions: {
        gcLabelLocation: "left",
      },
      formHeight: "auto",
      filterProcess: [],
      SaveType: null,
      ClickedRowData: null,
      nextPathTo: null,
    };
  },
  async created() {
    if (this.baseView.mode === "create") {
      this.formModel.BillNo = this.baseView.id;
      await this.resetFormToDefault();
    } else {
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        await this.getBomProcessByRecordId();
      } else {
        this.formModel.BillNo = JSON.parse(JSON.stringify(this.baseView.id));
      }
    }

    this.$nextTick(() => {
      this.loaded = true;

      this.focusOnForm();
    });
  },
  async mounted() {},
  beforeDestroy() {},

  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    backButtonRoute() {
      return "/bill-of-materials";
    },
    getFormBackURL() {
      return "/bill-of-materials-processes/" + this.formModel.BillNo;
    },
    getTabs() {
      return BillOfMaterialsTabs(this.setBaseView);
    },
    selectedTabIndex() {
      return GetIndexByTabName("Processes", this.setBaseView);
    },

    setBaseView() {
      let baseView = { ...this.baseView };
      baseView.id = this.formModel.BillNo;

      return baseView;
    },

    showLeftContainer() {
      return true;
    },

    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },

    getProcessFilter() {
      let items = this.filterProcess;
      let filter = [["Inactive", "=", "N"]];
      let processFilter = [];
      if (items && items.length > 0) {
        items.forEach((element) => {
          if (element) {
            if (processFilter.length > 0) {
              processFilter.push("and");
            }

            if (
              this.baseView.mode === "edit" &&
              this.formModel.ProcessCode === element
            ) {
              // In Edit mode allow to select the same process
              return;
            }
            processFilter.push(["Code", "<>", element]);
          }
        });
      }

      if (processFilter.length > 0) {
        filter.push("and");
        filter.push(processFilter);
      }
      return filter;
    },

    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "ProcessCode",
              label: { text: "Process", location: "left" },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: BillOfMaterialsService.dataSourceConfig(
                  "api/Process",
                  {
                    filter:
                      this.baseView.mode === "create"
                        ? this.getProcessFilter
                        : null,
                    sort: "Code asc",
                  }
                ),
                valueExpr: "Code",
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Code}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description}
                            </span>
                          </div>`;
                },
                searchEnabled: true,
                showClearButton: true,
                placeholder: "Select Process",
                onSelectionChanged: this.onProcessChange,
                tabIndex: 1,
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Process is required",
                },
              ],
            },

            {
              dataField: "ProcessDescription",
              label: { text: "Process Description", location: "left" },
              editorType: "dxTextBox",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
              visible: false, // Removed as new UX change
            },

            {
              dataField: "RatePerHour",
              label: { text: "Rate / Hour", location: "left" },
              editorType: "dxNumberBox",
              editorOptions: {
                format: "##,###,###,###,##0.0000",
                tabIndex: 2,
                onValueChanged: this.onHourValueChanged,
              },
              required: true,
              validationRules: [
                {
                  type: "range",
                  min: 0.0,
                  message:
                    "Rate / Hour must be greater than or equal to 0.0000",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "Minutes",
                  colCount: 1,
                  cssClass: "minutes-group",
                  items: [
                    {
                      dataField: "SetupMinutes",
                      label: { text: "Setup Time", location: "left" },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        format: "##,###,###,###,##0.0000",
                        tabIndex: 3,
                        onValueChanged: this.onSetupMinutesValueChanged,
                      },
                      validationRules: [
                        {
                          type: "range",
                          min: 0.0,
                          message:
                            "Setup Time (Minutes) must be greater than or equal to 0.0000",
                        },
                      ],
                    },
                    {
                      dataField: "TimeMinutes",
                      label: { text: "Process Time", location: "left" },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        format: "##,###,###,###,##0.0000",
                        tabIndex: 5,
                        onValueChanged: this.onTimeMinutesValueChanged,
                      },
                      validationRules: [
                        {
                          type: "range",
                          min: 0.0,
                          message:
                            "Process Time (Minutes) must be greater than or equal to 0.0000",
                        },
                      ],
                    },
                    {
                      dataField: "ProcessOffsetMinutes",
                      label: {
                        text: "Process Offset",
                        location: "left",
                      },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        format: "##,###,###,###,##0.0000",
                        tabIndex: 7,
                        onValueChanged: this.onProcessOffsetMinutesValueChanged,
                      },
                      validationRules: [
                        {
                          type: "range",
                          min: 0.0,
                          message:
                            "Process Offset (Minutes) must be greater than or equal to 0.0000",
                        },
                      ],
                    },
                  ],
                },

                {
                  itemType: "group",
                  caption: "Hours",
                  colCount: 1,
                  cssClass: "hours-group",
                  items: [
                    {
                      dataField: "SetupHours",
                      label: { text: "Setup Time", visible: false },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        format: "##,###,###,###,##0.0000",
                        tabIndex: 4,
                        onValueChanged: this.onSetupHoursValueChanged,
                      },
                      validationRules: [
                        {
                          type: "range",
                          min: 0.0,
                          message:
                            "Setup Time (Hours) must be greater than or equal to 0.0000",
                        },
                      ],
                    },
                    {
                      dataField: "TimeHours",
                      label: { text: "Process Time", visible: false },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        format: "##,###,###,###,##0.0000",
                        tabIndex: 6,
                        onValueChanged: this.onTimeHoursValueChanged,
                      },
                      validationRules: [
                        {
                          type: "range",
                          min: 0.0,
                          message:
                            "Process Time (Hours) must be greater than or equal to 0.0000",
                        },
                      ],
                    },
                    {
                      dataField: "ProcessOffsetHours",
                      label: { text: "Process Offset", visible: false },
                      editorType: "dxNumberBox",
                      editorOptions: {
                        format: "##,###,###,###,##0.0000",
                        tabIndex: 8,
                        onValueChanged: this.onProcessOffsetHoursValueChanged,
                      },
                      validationRules: [
                        {
                          type: "range",
                          min: 0.0,
                          message:
                            "Process Offset (Hours) must be greater than or equal to 0.0000",
                        },
                      ],
                    },
                  ],
                },
              ],
            },

            {
              dataField: "ProcessOffsetAnchor",
              label: { text: "Apply Offset From", location: "left" },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: [
                  { id: "StartOfProcess", Name: "Process Start Time" },
                  { id: "EndOfProcess", Name: "Process End Time" },
                ],
                displayExpr: "Name",
                valueExpr: "id",
                searchEnabled: true,
                showClearButton: true,
                tabIndex: 9,
              },
            },

            {
              dataField: "Sequence",
              label: { text: "Sequence" },
              editorType: "dxNumberBox",
              editorOptions: {
                format: "##,###,###,###,##0",
                min: 1,
                tabIndex: 10,
              },
            },
            {
              dataField: "Comment",
              label: { text: "Comment", location: "top" },
              editorType: "dxTextArea",
              cssClass: "comment-textarea",
              editorOptions: {
                height: 90,
                maxLength: 1000,
                showClearButton: true,
                tabIndex: 11,
              },
            },
          ],
        },
      ];
    },
    getHeaderToolbar() {
      return {
        closeSplit: true,
        save: this.isUserEntryAllowed && this.baseView.mode === "review",
        audit: true,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
            ],
          },
        ],
        toolbarFormLocation: "after",
        editURL: "/bill-of-materials-processes",
        editCallBack: this.editCallBack,
        delete:
          this.baseView.mode !== "create" && this.isUserEntryAllowed
            ? true
            : false,
        deleteCallBack: this.deleteCallBack,
        customButtons:
          this.isUserEntryAllowed && this.baseView.mode !== "review"
            ? [
                {
                  widget: "dxDropDownButton",
                  icon: "floppy",
                  text: "",
                  showArrowIcon: false,
                  items: [
                    {
                      text: "Save + Add New",
                      type: "normal",
                    },
                    {
                      text: "Save + Preview",
                      type: "normal",
                    },
                    {
                      text: "Save & Close",
                      type: "normal",
                    },
                  ],
                  dropDownOptions: {
                    width: 120,
                  },
                  onItemClick: this.onSaveProcess,
                },
              ]
            : undefined,
      };
    },

    getGridHeight() {
      return this.gridHeight - 20;
    },

    getGridColumns() {
      return [
        {
          caption: "Process",
          dataField: "ProcessCode",
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth + 50,
          cellTemplate: "RecordTemplate",
        },
        {
          caption: "Setup Time (Mins)",
          dataField: "Setup",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Process Time (Mins)",
          dataField: "Time",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Rate / Hour",
          dataField: "RatePerHour",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Process Offset (Mins)",
          dataField: "ProcessOffsetMinutes",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth + 10,
          format: "##,###,###,###,##0.0000",
        },
        {
          caption: "Seq No",
          dataField: "SeqNo",
          dataType: "number",
        },
        {
          caption: "Comment",
          dataField: "Comment",
          cssClass: "edit-cell-textbox-field comment-text",
          minWidth: ColumnWidth.Comment.minWidth,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
        },
      ];
    },
    getDataSource() {
      return BillOfMaterialsService.dataSourceConfig("api/BomProcessList", {
        filter: [["BomCode", "=", this.formModel.BillNo]],
        sort: [{ selector: "SeqNo", asc: true }],
      });
    },

    getFormHeight() {
      if (this.formConfig && this.formConfig.formHeight)
        return this.formConfig.formHeight;
      else return "auto";
    },

    isUserEntryAllowed() {
      return FeatureStorage.checkPermission("BillOfMaterial", "create");
    },
  },
  methods: {
    async valueChangeCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.SaveBomNewProcess();
      }

      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    /* Save Process Methods */
    async SaveBomNewProcess() {
      this.showLoading(true);

      try {
        const payload = this.getPayload();
        const response = await BillOfMaterialsService.SaveBomNewProcess(
          payload
        );

        if (!response) return;

        this.setIgnoreRouteChangeConfirmation();

        // Case 1 – Save + Add New
        if (this.SaveType === "Save + Add New") {
          await this.handleSaveAddNew();
          return;
        }

        // Case 2 – Save + Preview / Save + Edit
        if (
          this.SaveType === "Save + Preview" ||
          this.SaveType === "Save + Edit"
        ) {
          await this.handleSavePreviewOrEdit(response);
          this.$refs["data-grid"].instance.getDataSource().reload();
          return;
        }

        // Case 3 – Save + Move (route change)
        if (this.SaveType === "Save + Move" && this.nextPathTo) {
          await this.$router.push({ path: this.nextPathTo });
          return;
        }

        // Default (normal save)
        this.goBackToList();
      } catch (error) {
        this.displayServerError(
          error,
          "Error saving Process to Bill of Materials"
        );
      } finally {
        this.showLoading(false);
      }
    },

    /**
     * Handles Save + Add New action
     */
    async handleSaveAddNew() {
      await this.$refs["data-grid"].instance.refresh();
      await this.$nextTick();

      if (this.baseView.mode !== "create") {
        this.createNewProcess();
        return;
      }

      await this.resetFormToDefault();

      setTimeout(() => {
        this.$nextTick(() => this.focusOnForm());
      }, 200);
    },

    /**
     * Handles Save + Preview or Save + Edit actions
     * @param response
     */
    async handleSavePreviewOrEdit(response) {
      const isPreview =
        !this.ClickedRowData || this.SaveType === "Save + Preview";

      const processCode = isPreview
        ? this.formModel.ProcessCode
        : this.ClickedRowData.ProcessCode;

      const sequence = isPreview
        ? this.formModel.Sequence
        : this.ClickedRowData.SeqNo;

      // Find the record ID from the API response
      const record = response.data.BomNewProcessDetails.find(
        (x) => x.ProcessCode === processCode && x.SeqNo === sequence
      );

      if (!record) {
        this.goBackToList();
        return;
      }

      const pathName = isPreview
        ? "bill-of-materials-processes-review"
        : "bill-of-materials-processes-edit";

      await this.$router.push({
        name: pathName,
        params: { id: record.RecordId },
      });

      this.$nextTick(() => this.getBomProcessByRecordId());
    },

    goBackToList() {
      this.$nextTick(() => {
        this.setIgnoreRouteChangeConfirmation();
        this.$router
          .push({
            path: this.getFormBackURL,
          })
          .then(() => {
            this.$refs["data-grid"].instance.refresh();
          });
      });
    },
    getPayload() {
      const items = this.$refs["data-grid"].instance.getDataSource().items();
      let BomNewProcessDetails = [];

      let userEnteredSeqNo = this.formModel.Sequence;
      let maxExistingSeqNo = items.length;

      // Adjust userEnteredSeqNo if it exceeds the max
      if (userEnteredSeqNo > maxExistingSeqNo) {
        if (this.baseView.mode === "create") {
          userEnteredSeqNo = maxExistingSeqNo + 1;
        } else {
          // For edit mode, cap at maxExistingSeqNo
          userEnteredSeqNo = maxExistingSeqNo;
        }
      }

      // Filter out the record being edited (if in edit mode)
      const otherRecords = items.filter(
        (x) => x.RecordId._value !== this.baseView.id
      );

      // Map existing records with recalculated sequence numbers
      BomNewProcessDetails = otherRecords.map((x, index) => {
        // Calculate the original sequence (1-based index)
        const originalSeqNo = index + 1;

        // Determine the new sequence number
        let newSeqNo;
        if (originalSeqNo < userEnteredSeqNo) {
          // Records before the user-entered position stay the same
          newSeqNo = originalSeqNo;
        } else {
          // Records at or after the user-entered position shift up by 1
          newSeqNo = originalSeqNo + 1;
        }

        return {
          ProcessCode: x.ProcessCode,
          Setup: x.Setup,
          Time: x.Time,
          RatePerHour: x.RatePerHour,
          Handling: x.Handling,
          Comment: x.Comment,
          ProcessOffsetMinutes: x.ProcessOffsetMinutes,
          ProcessOffsetAnchor: x.ProcessOffsetAnchor,
          SeqNo: newSeqNo,
          BomCode: x.BomCode,
          RecordId: x.RecordId,
        };
      });

      BomNewProcessDetails.push({
        ProcessCode: this.formModel.ProcessCode,
        Setup: this.formModel.SetupMinutes,
        Time: this.formModel.TimeMinutes,
        RatePerHour: this.formModel.RatePerHour,
        Handling: 0,
        Comment: this.formModel.Comment,
        ProcessOffsetMinutes: this.formModel.ProcessOffsetMinutes,
        ProcessOffsetAnchor: this.formModel.ProcessOffsetAnchor,
        SeqNo: userEnteredSeqNo,
        BomCode: this.formModel.BillNo,
        RecordId:
          this.baseView.mode === "create"
            ? "00000000-0000-0000-0000-000000000000"
            : this.baseView.id,
      });

      return {
        BomCode: this.formModel.BillNo,
        BomNewProcessDetails: BomNewProcessDetails,
      };
    },

    formContentReady(e) {
      if (e)
        this.formHeight =
          this.heigthForForm -
          document.getElementsByClassName("form-header-toolbar")[0]
            .clientHeight -
          40;
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      // var columnChooserButton = toolbarItems.find((item) => {
      //   return item.name === "columnChooserButton";
      // });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            visible: this.isUserEntryAllowed,
            onClick: async () => {
              if (this.baseView.mode !== "review") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes"
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewProcess();
                }
              } else {
                this.createNewProcess();
              }
            },
            // disabled: true,
          },
        },
        searchPanel
        // columnChooserButton
      );
    },

    async resetFormToDefault() {
      this.formModel.ProcessCode = null;
      this.formModel.ProcessDescription = null;
      this.formModel.RatePerHour = 0;
      this.formModel.SetupMinutes = 0;
      this.formModel.SetupHours = 0;
      this.formModel.TimeMinutes = 0;
      this.formModel.TimeHours = 0;
      this.formModel.ProcessOffsetMinutes = 0;
      this.formModel.ProcessOffsetHours = 0;
      this.formModel.Comment = "";
      this.formModel.ProcessOffsetAnchor = "EndOfProcess";
      this.formModel.Sequence = null;

      await this.getAddedMaterialProcesses();
      await this.getBOMProcessesMaxSeqNo();
    },

    async getAddedMaterialProcesses() {
      try {
        const response = await BillOfMaterialsService.getAddedMaterialProcesses(
          this.formModel.BillNo
        );
        if (response && response.data && response.data.length > 0) {
          this.filterProcess = response.data.map((item) => item.ProcessCode);
        } else {
          this.filterProcess = [];
        }
      } catch (error) {
        this.displayServerError(error);
        return [];
      }
    },

    editCallBack() {
      this.$nextTick(() => {
        this.focusOnForm();
      });
    },

    async createNewProcess() {
      await this.resetFormToDefault();
      this.$router
        .push({
          path: `/bill-of-materials-processes/create/${this.formModel.BillNo}`,
        })
        .then(() => {
          this.$nextTick(() => {
            this.focusOnForm();
          });
        });
    },

    focusOnForm() {
      this.$nextTick(() => {
        if (
          this.$refs["split-view-form"] &&
          this.$refs["split-view-form"].$refs["gc-form-comp"]
        ) {
          const formInstance =
            this.$refs["split-view-form"].$refs["gc-form-comp"].instance;
          if (formInstance) {
            const firstElement = formInstance.getEditor("ProcessCode");
            if (firstElement) {
              firstElement.focus();
            }
          }
        }
      });
    },

    /**
     * On Content Ready
     * @param e Event
     */
    onContentReady(e) {
      if (e) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Processes",
            message:
              "There are no processes linked to this Bill of Materials. Add a new process.",
          },
        });
      }
      this.$nextTick(() => {
        this.reSizeGrid(e.component);
      });
    },

    /**
     * Resize Grid
     * @param component Grid Component
     */
    reSizeGrid(component) {
      component.beginUpdate();
      component.updateDimensions();
      component.endUpdate();
    },

    // From Functions
    /**
     * On Process Change
     * @param e Event
     */
    onProcessChange(e) {
      if (e.selectedItem) {
        this.formModel.ProcessDescription = e.selectedItem.Description;
      } else {
        this.formModel.ProcessDescription = "";
      }
    },

    /**
     * Get BOM Processes Max Seq No
     */
    async getBOMProcessesMaxSeqNo() {
      try {
        const response = await BillOfMaterialsService.getBOMProcessesMaxSeqNo(
          this.formModel.BillNo
        );
        if (response && response.data && response.data.length > 0) {
          this.formModel.Sequence = response.data[0].MaxSeqNo + 1;
        } else {
          this.formModel.Sequence = 1;
        }
      } catch (error) {
        this.displayServerError(error);
      }
    },

    /**
     *  On Hour Value Changed
     * @param e Event
     */
    onHourValueChanged(e) {
      if (e.event) {
        this.formModel.RatePerHour = e.value;
        if (e.value === 0) {
          this.formModel.TimeMinutes = 0;
          this.formModel.TimeHours = 0;
          return;
        }
        this.formModel.TimeMinutes = (60 / e.value).roundNumber(4);
        this.formModel.TimeHours = (1 / e.value).roundNumber(4);
      }
    },

    /**
     * On Setup Minutes Value Changed
     * @param e Event
     */
    onSetupMinutesValueChanged(e) {
      if (e.event) {
        this.formModel.SetupMinutes = e.value;
        if (e.value === 0) {
          this.formModel.SetupHours = 0;
          return;
        }
        this.formModel.SetupHours = (e.value / 60).roundNumber(4);
      }
    },

    /**
     * On Time Minutes Value Changed
     * @param e Event
     */
    onTimeMinutesValueChanged(e) {
      if (e.event) {
        this.formModel.TimeMinutes = e.value;
        if (e.value === 0) {
          this.formModel.TimeHours = 0;
          this.formModel.RatePerHour = 0;
          return;
        }
        this.formModel.TimeHours = (e.value / 60).roundNumber(4);
        this.formModel.RatePerHour = (60 / e.value).roundNumber(4);
      }
    },

    /**
     * On Process Offset Minutes Value Changed
     * @param e Event
     */
    onProcessOffsetMinutesValueChanged(e) {
      if (e.event) {
        this.formModel.ProcessOffsetMinutes = e.value;
        if (e.value === 0) {
          this.formModel.ProcessOffsetHours = 0;
          return;
        }
        this.formModel.ProcessOffsetHours = (e.value / 60).roundNumber(4);
      }
    },

    /**
     * On Setup Hours Value Changed
     * @param e Event
     */
    onSetupHoursValueChanged(e) {
      if (e.event) {
        this.formModel.SetupHours = e.value;
        if (e.value === 0) {
          this.formModel.SetupMinutes = 0;
          return;
        }
        this.formModel.SetupMinutes = (e.value * 60).roundNumber(4);
      }
    },

    /**
     * On Time Hours Value Changed
     * @param e Event
     */
    onTimeHoursValueChanged(e) {
      if (e.event) {
        this.formModel.TimeHours = e.value;
        if (e.value === 0) {
          this.formModel.TimeMinutes = 0;
          this.formModel.RatePerHour = 0;
          return;
        }
        this.formModel.TimeMinutes = (e.value * 60).roundNumber(4);
        this.formModel.RatePerHour = (1 / e.value).roundNumber(4);
      }
    },

    /**
     * On Process Offset Hours Value Changed
     * @param e Event
     */
    onProcessOffsetHoursValueChanged(e) {
      if (e.event) {
        this.formModel.ProcessOffsetHours = e.value;
        if (e.value === 0) {
          this.formModel.ProcessOffsetMinutes = 0;
          return;
        }
        this.formModel.ProcessOffsetMinutes = (e.value * 60).roundNumber(4);
      }
    },

    /**
     * Show Unsaved Changes Dialog
     */
    showUnsavedChangesDialog() {
      return custom({
        title: "Unsaved Changes",
        messageHtml: `You have unsaved changes. Do you want to discard your changes or save them before proceeding?`,
        buttons: [
          {
            text: "Save Changes",
            onClick: (e) => ({ buttonText: e.component.option("text") }),
          },
          {
            text: "Discard Changes",
            onClick: (e) => ({ buttonText: e.component.option("text") }),
          },
        ],
      }).show();
    },

    /**
     * Handle Unsaved Navigation
     * @param {Function} saveCallback - Callback function to execute when saving changes.
     * @param {Function} discardCallback - Callback function to execute when discarding changes.
     */
    async handleUnsavedNavigation(saveCallback, discardCallback) {
      this.setIgnoreRouteChangeConfirmation();

      const dialogResult = await this.showUnsavedChangesDialog();

      if (dialogResult.buttonText === "Save Changes") {
        await saveCallback();
      } else {
        await discardCallback();
      }
    },

    /**
     * On Route Change Call Back
     * @param {string} pathTo - The path to navigate to.
     */
    async onRouteChangeCallBack(pathTo) {
      this.nextPathTo = pathTo;

      await this.handleUnsavedNavigation(
        async () => {
          await this.onSaveProcess({ itemData: { text: "Save + Move" } });
        },
        async () => {
          await this.$router.push({ path: pathTo });
          this.$nextTick(() => this.getBomProcessByRecordId());
        }
      );
    },

    /**
     * On Row Click
     * @param e Event
     */
    async onRowClick(e) {
      if (!e.event) return;
      this.ClickedRowData = e.data;
      if (this.ClickedRowData.RecordId._value === this.baseView.id) return;

      // If currently editing and clicking a different row
      if (this.baseView.mode === "edit") {
        await this.handleUnsavedNavigation(
          async () => {
            await this.onSaveProcess({ itemData: { text: "Save + Edit" } });
          },
          async () => {
            await this.$router.push({
              name: "bill-of-materials-processes-edit",
              params: { id: this.ClickedRowData.RecordId },
            });
            this.$nextTick(() => this.getBomProcessByRecordId());
          }
        );
      } else {
        // Normal navigation
        await this.$router.push({
          name: "bill-of-materials-processes-review",
          params: { id: this.ClickedRowData.RecordId },
        });
        this.$nextTick(() => this.getBomProcessByRecordId());
      }
    },
    /**
     * Get BOM Process By Record Id
     */
    async getBomProcessByRecordId() {
      this.showLoading(true);
      try {
        const response = await BillOfMaterialsService.getBomProcessByRecordId(
          this.baseView.id
        );

        if (IsResponseDataValid(response)) {
          const data = response.data.value[0];
          this.formModel.BillNo = data.BomCode;
          this.formModel.ProcessCode = data.ProcessCode;
          this.formModel.ProcessDescription = data.ProcessDescription;
          this.formModel.RatePerHour = data.RatePerHour;

          if (
            this.formModel.RatePerHour &&
            this.formModel.RatePerHour > 0 &&
            data.Time === 0
          ) {
            this.formModel.TimeMinutes = (
              60 / this.formModel.RatePerHour
            ).roundNumber(4);
            this.formModel.TimeHours = (
              1 / this.formModel.RatePerHour
            ).roundNumber(4);
          } else if (data.Time && data.Time > 0) {
            this.formModel.TimeMinutes = data.Time;
            this.formModel.TimeHours = (data.Time / 60).roundNumber(4);
          } else {
            this.formModel.TimeMinutes = 0;
            this.formModel.TimeHours = 0;
          }
          this.formModel.Sequence = data.SeqNo;
          this.formModel.SetupMinutes = data.Setup;
          this.formModel.SetupHours = (data.Setup / 60).roundNumber(4);
          this.formModel.ProcessOffsetMinutes = data.ProcessOffsetMinutes;
          this.formModel.ProcessOffsetHours = (
            data.ProcessOffsetMinutes / 60
          ).roundNumber(4);
          this.formModel.ProcessOffsetAnchor = data.ProcessOffsetAnchor;
          this.formModel.Comment = data.Comment;

          this.formModel.DateChanged = data.DateChanged;
          this.formModel.DateCreated = data.DateCreated;
          this.formModel.ChangedBy = data.ChangedBy;
          this.formModel.CreatedBy = data.CreatedBy;
        }
      } catch (error) {
        this.displayServerError(error);
      } finally {
        this.showLoading(false);
      }
    },

    /**
     * Delete Call Back
     */
    async deleteCallBack() {
      const confirm = await this.$confirm(
        "Are you sure you want to delete this process from Bill of Materials?",
        "Confirm Deletion",
        {
          confirmButtonText: "Delete",
          type: "warning",
        }
      );

      if (confirm) {
        this.showLoading(true);

        try {
          const response = await BillOfMaterialsService.deleteBomProcess(
            this.baseView.id
          );

          if (response) {
            this.$nextTick(() => {
              this.setIgnoreRouteChangeConfirmation();
              this.$router
                .push({
                  path: this.getFormBackURL,
                })
                .then(() => {
                  this.$refs["data-grid"].instance.refresh(true);
                });
            });
          }
        } catch (error) {
          this.displayServerError(
            error,
            "Error deleting Process from Bill of Materials"
          );
        } finally {
          this.showLoading(false);
        }
      }
    },

    onSaveProcess(action) {
      this.SaveType = action.itemData.text;
      this.isValid = true;
    },
  },
  watch: {
    getHotKeySave(newVal) {
      if (newVal) {
        this.$store.dispatch("hotKey/setHotKeySave", false);
        this.onSaveProcess({ itemData: { text: "Save + Add New" } });
      }
    },
  },
};
</script>

<style lang="scss">
.bill-of-materials {
  .pack-size {
    padding-right: 0 !important;
  }
  .batch-size {
    padding-left: 10 !important;
    > label {
      // width: 75px !important;
    }
  }
  .minutes-group {
    padding-right: 0 !important;
  }
  .minutes-group,
  .hours-group {
    padding-top: 10px;
    .dx-form-group-caption {
      width: 100% !important;
      display: block !important;
      text-align: end !important;

      font-family: Roboto;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      color: #323842;
    }
  }
}
</style>
